export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'opt',
    },
  },

  {
    title: that.$l('table_label_fabricInspectionNo') || '面料检验单号',
    field: 'inspectionNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
  },

  {
    title: that.$l('table_label_status') || '状态',
    field: 'status',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    slots: {
      default: 'status',
    },
  },
  {
    title: that.$l('table_label_auditResultType') || '审核结果',
    field: 'auditResultType',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    slots: {
      default: 'auditResultType',
    },
  },
  {
    title: that.$l('table_label_purchaseMaterialCode') || '物料编码/名称',
    field: 'purchaseMaterialCode',
    width: 200,
    align: 'left', headerAlign: 'center',

    showHeaderOverflow: true,
    slots: {
      default: 'purchaseMaterial',
    },
  },
  {
    title: that.$l('table_label_fabricWidthCode') || '门幅/克重',
    field: 'fabricWidth',
    width: 160,
    align: 'left', headerAlign: 'center',
    showHeaderOverflow: true,
    slots: {
      default: 'fabricWidth',
    },
  },
  {
    title: that.$l('table_label_fabricContent') || '规格型号',
    field: 'fabricContent',
    width: 180,
    align: 'left',
    showHeaderOverflow: true,
  },
  // {
  //   title: that.$l('table_label_materialRequirement') || '材质要求',
  //   field: 'materialRequirement',
  //   width: 160,
  //   align: 'center',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  {
    title: that.$l('table_label_arrivalDate') || '实际到料日期',
    field: 'arrivalDate',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_inspectionDate') || '检验日期',
    field: 'inspectionDate',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_reporterNames') || '质检员',
    field: 'reporterNames',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'reporterNames' }
  },
  {
    title: that.$l('table_label_totalArrivalQuantity') || '来料数量',
    field: 'totalArrivalQuantity',
    width: 130,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: {
      default: 'totalArrivalQuantity',
    },
  },
  {
    title: that.$l('table_label_totalInspectQuantity') || '检验米数',
    field: 'totalInspectQuantity',
    width: 130,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: {
      default: 'totalInspectQuantity',
    },
  },
  {
    title: that.$l('table_label_totalInspectionRolls') || '检验匹数',
    field: 'totalInspectionRolls',
    width: 130,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: {
      default: 'totalInspectionRolls',
    },
  },
  {
    title: that.$l('table_label_totalDefectCount_slot') || '疵点/利用率',
    field: 'totalDefectCount',
    width: 130,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: {
      default: 'totalDefectCount',
    },
  },
  {
    title: that.$l('table_label_totalLetGoQuantity') || '让步接收数量(米)',
    field: 'totalLetGoQuantity',
    width: 130,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_shortQuantity') || '短码数量(米)',
    field: 'totalShortQuantity',
    width: 130,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_totalReturnQuantity') || '退货数量(米)',
    field: 'totalReturnQuantity',
    width: 130,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_v_inspectionResult') || '判定结果',
    field: 'v_inspectionResult',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_purchaseFabricNo') || '采购单号',
    field: 'purchaseFabricNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_originOrderNo') || '源头订单号',
    field: 'originOrderNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },

  {
    title: that.$l('table_label_scmName') || '供方',
    field: 'scmName',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },

  {
    title: that.$l('table_label_purchaserEntityName') || '需方',
    field: 'purchaserEntityName',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_buyerName') || '采购员',
    field: 'buyerName',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 170,
    slots: { default: 'createInfo' }
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 170,
    slots: { default: 'modifyInfo' }
  },
]
